import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Injectable} from '@angular/core';
import {LoanApplicationService} from '../service/loan-application.service';
import {Keys, StorageService} from '../service/storage.service';

@Injectable()
export class ActiveApplicationValidationGuard implements CanActivate {
    constructor(private router: Router, private loanApplicationService: LoanApplicationService,
                private storageService: StorageService) {
    }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
        const applicationId = route.params.applicationId;
        const loanApplication = await this.loanApplicationService.getLoanApplication(applicationId);

        if (loanApplication) {
            this.storageService.saveObject(Keys.LOAN_APPLICATION, loanApplication);
            return this.router.createUrlTree(['/borrow/summary']);
        } else {
            return this.router.createUrlTree(['/borrow']);
        }
    }
}